/**
 * Limpieza de datos legacy en localStorage del consultorio.
 * La persistencia clínica y flags de migración viven en PostgreSQL (API).
 * Solo cookies JWT para autenticación.
 */

/** Solo flags/caché (se pueden borrar al iniciar sesión). */
export const CONSULTORIO_FLAG_LS_KEYS = [
  'app_migrated_full_v1',
  'app_clinical_migrated_v1',
  'app_migrated_clinical_v1',
  'app_tenant_storage_limits',
  'app_tenant_storage_usage_cache',
  'app_consultorio_clinical_media',
];

export const CONSULTORIO_LEGACY_LS_KEYS = [
  ...CONSULTORIO_FLAG_LS_KEYS,
  'app_pacientes',
  'app_citas',
  'app_dental_charts',
  'app_radiografias',
  'app_recetas',
  'app_pagos_consultorio',
  'app_productos_consultorio',
  'app_facturas_consultorio',
  'app_sesiones_tratamiento',
  'app_ficha_medica_catalogos',
  'app_consentimiento_plantilla_tenant_v2',
  'app_consentimiento_plantilla_consultorio',
  'consultorio_token',
  'token',
  'ecommers_professional_profile_v1',
];

const PREFIXES_TO_REMOVE = [
  'app_',
  'periodontograma_',
  'pd_section_',
  'app_diente_config_',
];

/** Elimina solo flags/caché en localStorage (seguro en cada arranque). */
export function purgeConsultorioFlagsOnly() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  CONSULTORIO_FLAG_LS_KEYS.forEach((k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      /* noop */
    }
  });
}

/** Elimina todo lo legacy del consultorio (tras migrar a PostgreSQL). */
export function purgeConsultorioLocalStorage() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  purgeConsultorioFlagsOnly();
  CONSULTORIO_LEGACY_LS_KEYS.forEach((k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      /* noop */
    }
  });
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const k = localStorage.key(i);
      if (!k) continue;
      if (PREFIXES_TO_REMOVE.some((p) => k.startsWith(p))) {
        localStorage.removeItem(k);
      }
    }
  } catch {
    /* noop */
  }
}
